import React, { useState } from 'react';
import { useCliente } from '../../hooks/useCliente';
import { useFavoritos } from '../../hooks/useFavoritos';
import { PropertyCard } from '../Properties/PropertyCard';
import { PropertyDetailsModal } from '../PropertyDetails/PropertyDetailsModal';
import { CadastroClienteModal } from '../Cliente/CadastroClienteModal';
import './FavoritosPage.css';

export const FavoritosPage: React.FC = () => {
  const { cliente, getClienteId, isClienteCadastrado } = useCliente();
  const clienteId = getClienteId();
  const { favoritos, total, loading, error, listarFavoritos } = useFavoritos(clienteId);
  const [showCadastroModal, setShowCadastroModal] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePropertyClick = (imovel: any) => {
    setSelectedProperty(imovel);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProperty(null);
  };

  const handleCadastroSuccess = () => {
    setShowCadastroModal(false);
    // Recarregar favoritos após cadastro
    setTimeout(() => {
      listarFavoritos();
    }, 500);
  };

  // Se não há cliente cadastrado, mostrar mensagem e botão para cadastrar
  if (!isClienteCadastrado()) {
    return (
      <div className="favoritos-page">
        <div className="favoritos-container">
          <div className="favoritos-header">
            <h1>Meus Favoritos</h1>
          </div>
          <div className="favoritos-empty-state">
            <h2>Faça seu cadastro para salvar favoritos</h2>
            <p>Cadastre-se gratuitamente para salvar seus imóveis favoritos e receber novidades.</p>
            <button 
              className="cadastro-btn"
              onClick={() => setShowCadastroModal(true)}
            >
              Fazer Cadastro
            </button>
          </div>
        </div>

        <CadastroClienteModal
          isOpen={showCadastroModal}
          onClose={() => setShowCadastroModal(false)}
          onSuccess={handleCadastroSuccess}
        />
      </div>
    );
  }

  return (
    <div className="favoritos-page">
      <div className="favoritos-container">
        <div className="favoritos-header">
          <h1>Meus Favoritos</h1>
          {cliente && (
            <p className="favoritos-subtitle">
              Olá, {cliente.nome}! Você tem {total} {total === 1 ? 'imóvel favorito' : 'imóveis favoritos'}
            </p>
          )}
        </div>

        {loading && (
          <div className="favoritos-loading">
            <div className="loading-spinner"></div>
            <p>Carregando seus favoritos...</p>
          </div>
        )}

        {error && (
          <div className="favoritos-error">
            <p>Erro ao carregar favoritos: {error}</p>
            <button onClick={listarFavoritos} className="retry-btn">
              Tentar novamente
            </button>
          </div>
        )}

        {!loading && !error && total === 0 && (
          <div className="favoritos-empty-state">
            <h2>Você ainda não tem favoritos</h2>
            <p>Explore nossos imóveis e adicione os que mais gostar aos seus favoritos!</p>
            <button 
              className="explore-btn"
              onClick={() => window.location.href = '/search'}
            >
              Explorar Imóveis
            </button>
          </div>
        )}

        {!loading && !error && total > 0 && (
          <div className="favoritos-grid">
            {favoritos.map((favorito) => (
              <PropertyCard
                key={favorito.favorito_id}
                imovel={favorito.imovel}
                onClick={handlePropertyClick}
              />
            ))}
          </div>
        )}
      </div>

      {/* Modal de detalhes do imóvel */}
      {selectedProperty && (
        <PropertyDetailsModal
          propertyId={selectedProperty.id}
          propertyData={selectedProperty}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

